<template>
  <div class="container">
    <p>{{supporttxt}}<a :href="chromeUrl" target="_blank" type="warning">Google Chrome</a>。</p>
    <!-- <el-card style="max-width: 480px;margin: 50px auto;">
    <template #header>
      Nebula AI检测：
    </template>
    <p>当前浏览器是否是 SDK 支持的浏览器：<span>{{ checkDetail.isBrowserSupported }}</span></p>
    <p>当前浏览器是否支持 WebRTC：<span>{{ checkDetail.isWebRTCSupported }}</span></p>
    <p>当前浏览器是否支持 WebCodecs：<span>{{ checkDetail.isWebCodecsSupported }}</span></p>
    <p>当前浏览器是否支持获取媒体设备及媒体流：<span>{{ checkDetail.isMediaDevicesSupported }}</span></p>
    <p>当前浏览器是否支持屏幕分享：<span>{{ checkDetail.isScreenShareSupported }}</span></p>
    <p>当前浏览器是否支持小流：<span>{{ checkDetail.isSmallStreamSupported }}</span></p>
    <p>当前浏览器上行是否支持 H264 编码：<span>{{ checkDetail.isH264EncodeSupported }}</span></p>
    <p>当前浏览器下行是否支持 H264 编码：<span>{{ checkDetail.isH264DecodeSupported }}</span></p>
    <p>当前浏览器上行是否支持 VP8 编码：<span>{{ checkDetail.isVp8EncodeSupported }}</span></p>
    <p>当前浏览器下行是否支持 VP8 编码：<span>{{ checkDetail.isVp8DecodeSupported }}</span></p>
    <template #footer>您的浏览器不支持通话必要组件，推荐使用最新版Google Chrome浏览器</template>
  </el-card> -->
  </div>
</template>
<script>
import { useRoute } from 'vue-router'

export default {
  setup () {
    const route = useRoute()
    const lang = route.query.lang
    let chromeUrl = 'https://www.google.cn/chrome/'
    let supporttxt = '您的浏览器不支持通话必要组件，推荐使用最新版'
    if (lang !== 'zh') {
      chromeUrl = 'https://www.google.com/chrome/'
      supporttxt = 'Your browser does not support necessary calling components. We recommend using the latest version of '
    }
    return { chromeUrl, supporttxt }
  }
}
</script>
<style scoped>
.container{
  width: 90%;
  max-width: 800px;
  margin: 20px auto;
  text-align: center;
}
.container p{
  margin-bottom: 20px;
  font-size: 20px;
}
.container a{font-size: 20px;color: rgb(175, 19, 19);}
</style>
